import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, Pagination, TableHead, TableRow, Dialog, Box, TextField, Menu, MenuItem } from '@mui/material'
import { useSelector } from 'react-redux';
import { useAuthContext } from '../hooks/adminAuthHook'
import toast from 'react-hot-toast'
import AgenciesHook from '../hooks/AgenciesHook';
import { useNavigate, Link } from 'react-router-dom'
import {DownloadAgencies} from '../downloadingHooks/AgenciesCSV.js'
export default function Agencies() {


    const apiUrl = process.env.REACT_APP_API_URL;
    const { getAgencies } = AgenciesHook();
    const { admin } = useAuthContext()
    useEffect(() => {
        getAgencies()
        document.title = "Agencies"
    }, [])
    const collapsed = useSelector((state) => state.collapsed.collapsed);
    const agencies = useSelector((state) => state.agencies.agencies);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const rowsPerPage = 10;
    // Handle search input change
    const handleSearchChange = (event) => {
        setSearch(event.target.value);
        setPage(1);
    };

    // Handle pagination change
    const handlePageChange = (event, value) => {
        setPage(value);
    };


    // custom date range filter
    const [openModal, setOpenModal] = useState(false);

    const handleClickOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);

    }


    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [filterValue, setFilterValue] = useState('')

    // Getting filtered registered agencies
    const today = new Date();

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    const isWithinFilter = (agency) => {
        const agencyCreatedAt = new Date(agency.createdAt);
        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 7);

        // Ensure date strings are converted to Date objects and are valid
        const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

        if (filterValue === 'today') {
            return agencyCreatedAt.toDateString() === today.toDateString();
        } else if (filterValue === 'thisWeek') {
            return agencyCreatedAt >= sevenDaysAgo && agencyCreatedAt <= today;
        } else if (filterValue === 'custom') {
            // Handle empty strings gracefully
            const fromDate = dateFrom ? new Date(dateFrom) : undefined;
            const toDate = dateTo ? new Date(dateTo) : undefined;
            if (!isValidDate(fromDate) || !isValidDate(toDate)) {

                return false;
            }

            // Check if agencyCreatedAt is within the custom date range
            return agencyCreatedAt >= fromDate && agencyCreatedAt <= toDate;
        } else {
            return true; // 'all' case or any other default case
        }
    }


    const filteredAgencies = agencies?.filter((agency) => {
        const searchTerm = search.toLowerCase();
        const matchesSearch = (
            agency.name?.toLowerCase().includes(searchTerm) ||
            agency.phone?.toLowerCase().includes(searchTerm) ||
            agency.address?.toLowerCase().includes(searchTerm)
        )

        return matchesSearch && isWithinFilter(agency);

    }).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

    const paginatedAgencies = filteredAgencies && filteredAgencies.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    )

    //deleting the agency

    const deleteAgency = async (agencyId) => {
        if (window.confirm('Are you sure you want to delete?')) {

            try {
                const response = await fetch(`${apiUrl}/api/admin/agencies/delete`, {
                    method: "DELETE",
                    headers: {
                        'Authorization': `Bearer ${admin.token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ agencyId })
                })

                const json = await response.json()
                if (response.ok) {
                    toast.success(json.message)
                    getAgencies()

                }
                if (!response.ok) {
                    toast.error(json.message)

                }
            } catch (error) {
                toast.error(error.message)

            }
        }
    }
    //updating the agency
    const updateAgency = async (agencyId) => {
        if (window.confirm('Are you sure you want to update the agency status?')) {

            try {
                const response = await fetch(`${apiUrl}/api/admin/agencies/update`, {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${admin.token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ agencyId })
                })

                const json = await response.json()
                if (response.ok) {
                    toast.success(json.message)
                    getAgencies()

                }
                if (!response.ok) {
                    toast.error(json.message)

                }
            } catch (error) {
                toast.error(error.message)

            }
        }
    }


    // Approving/Rejecting Agency Registration/Account
    const [reason, setReason] = useState('')
    const [open, setOpen] = React.useState(false);
    const [agencyId, setAgencyId] = useState('')
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setAgencyId('')
        setReason('')
    };

    const agencyApproval = async (status, Id) => {
        if (window.confirm('Are you sure you want to perform this action?')) {
            toast.promise(
                new Promise(async (resolve, reject) => {
                    try {

                        const response = await fetch(`${apiUrl}/api/admin/agencies/approval`, {
                            method: "PUT",
                            headers: {
                                'Authorization': `Bearer ${admin.token}`,
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ agencyId: Id ? Id : agencyId, status, reason }),
                        });

                        const json = await response.json();

                        if (response.ok) {
                            resolve(json.message);
                            getAgencies()
                            handleClose()
                        } else {
                            reject(new Error(json.message)); // Use actual API message for error
                        }
                    } catch (error) {
                        reject(new Error(error.message)); // Handle unexpected errors
                    } finally {

                    }
                }),
                {
                    loading: "Processing...",
                    success: (message) => <b>{message}</b>,
                    error: (error) => <b>{error.message}</b>,
                }
            );
        }

    }



    const [anchorEl, setAnchorEl] = React.useState(null);
    const open1 = Boolean(anchorEl);
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const menuStyles = {
        borderRadius: '4px',
        backgroundColor: '#fff',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
    };

    const menuItemStyles = {
        padding: '4px 12px',
        fontSize: '12px',
        color: '#000',
        cursor: 'pointer'
    };

    const menuItemHoverStyles = {
        backgroundColor: '#f5f5f5'
    };
    return (
        <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
            <div className="container-fluid bg-none my-0 mt-0">
                <div className="row px-2 mt-5 pt-3">
                    <div className="col-md-12 data_table p-2 pb-3">
                        <div className="d-flex justify-content-between searchbar pb-2 pt-2 px-md-2 my-auto">
                            <div className="d-flex left my-auto mb-2 mb-md-0 ps-2 ps-md-0">
                                <h6>Agencies</h6>
                            </div>
                            <div className="d-flex right my-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 search_icon_svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                </svg>
                                <input type="text" value={search} onChange={handleSearchChange} placeholder='Seacrh..' />

                                {/* Filters button */}
                                <button className="filter_btn" id="basic-button" aria-controls={open1 ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open1 ? 'true' : undefined} onClick={handleClick1}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                                    </svg>
                                </button>
                                <button className="filter_btn" onClick={()=>DownloadAgencies(filteredAgencies)}>
                                <i className="fa-solid fa-download"></i>

                                </button>

                                {/* Menu for filter options */}
                                <Menu id="basic-menu" anchorEl={anchorEl} open={open1} onClose={handleClose1} MenuListProps={{ 'aria-labelledby': 'basic-button', style: menuStyles }}>
                                    <MenuItem onClick={() => { handleClose1(); setFilterValue(''); setDateFrom(''); setDateTo('') }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        All
                                    </MenuItem>
                                    <MenuItem onClick={() => { handleClose1(); setFilterValue('today'); setDateFrom(''); setDateTo('') }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        Today
                                    </MenuItem>
                                    <MenuItem onClick={() => { handleClose1(); setFilterValue('thisWeek'); setDateFrom(''); setDateTo('') }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        This Week
                                    </MenuItem>
                                    <MenuItem onClick={() => { handleClickOpenModal(); setFilterValue('custom');handleClose1()}} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        Custom Date
                                    </MenuItem>
                                    <MenuItem onClick={() => { setFilterValue(''); setDateFrom(''); setDateTo('');handleClose1() }} style={menuItemStyles} onMouseOver={(e) => e.currentTarget.style.backgroundColor = menuItemHoverStyles.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}>
                                        Default
                                    </MenuItem>
                                </Menu>
                            </div>
                        </div>
                        <TableContainer>
                            <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table" className='text-center'>
                                <TableHead >
                                    <TableRow >
                                        <TableCell className='th text-center' >ID</TableCell>
                                        <TableCell className='th text-center' >Created At</TableCell>
                                        <TableCell className='th text-center'>Name</TableCell>
                                        <TableCell className='th text-center'>Email</TableCell>
                                        <TableCell className='th text-center'>Phone</TableCell>
                                        <TableCell className='th text-center'>Whatsapp</TableCell>

                                        <TableCell className='th text-center'>Address</TableCell>
                                        <TableCell className='th text-center'>Bookings</TableCell>
                                        <TableCell className='th text-center'>Verfication Status</TableCell>
                                        <TableCell className='th text-center'>Status</TableCell>
                                        <TableCell className='th text-center'>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {filteredAgencies && filteredAgencies.length > 0 ? (
                                        filteredAgencies.map((data, index) => (
                                            <React.Fragment key={index}>
                                                <TableRow className="table_row">
                                                    <TableCell className="text-center td">{index + 1}</TableCell>
                                                    <TableCell className="text-center td">{new Date(data.createdAt).toLocaleString()}</TableCell>
                                                    <TableCell className="text-center td">{data.name}</TableCell>
                                                    <TableCell className="text-center td"><a href={`mailto:${data.email}`}>{data.email}</a></TableCell>
                                                    <TableCell className="text-center td">{data.phone}</TableCell>
                                                    <TableCell className='td text-center'><a href={`https://wa.me/${data.whatsapp_phone}`} target="_blank" rel="noreferrer">{data.whatsapp_phone}</a></TableCell>

                                                    <TableCell className="text-center td">{data.address}</TableCell>
                                                    <TableCell className="text-center td">{data.totalBookings}</TableCell>
                                                    <TableCell className="text-center td">{data.isVerified ? <i className="fas fa-user-check text-success"></i> : <i className="fas fa-user-times text-danger"></i>}</TableCell>
                                                    <TableCell className="text-center td">
                                                        <label className="switch my-auto" >
                                                            <input type="checkbox" disabled={!(data.isVerified)} checked={data.isActive} onClick={() => updateAgency(data._id)} />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </TableCell>
                                                    <TableCell className="text-center td">
                                                        <div class="btn-group" role="group" aria-label="Basic example">
                                                            <button onClick={() => {
                                                                window.open(`/agency/profile/${data._id}`, "_blank");
                                                            }}><svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M18.1959 9.49152C18.4527 9.85159 18.5811 10.0316 18.5811 10.2981C18.5811 10.5646 18.4527 10.7447 18.1959 11.1047C17.0422 12.7226 14.0956 16.2103 10.1352 16.2103C6.17466 16.2103 3.22814 12.7226 2.07438 11.1047C1.8176 10.7447 1.68921 10.5646 1.68921 10.2981C1.68921 10.0316 1.8176 9.85159 2.07438 9.49152C3.22814 7.87366 6.17466 4.38596 10.1352 4.38596C14.0956 4.38596 17.0422 7.87366 18.1959 9.49152Z" stroke="#6D76A1" stroke-width="1.52027" />
                                                                    <path d="M12.6689 10.2981C12.6689 8.89872 11.5345 7.76431 10.1351 7.76431C8.73573 7.76431 7.60132 8.89872 7.60132 10.2981C7.60132 11.6975 8.73573 12.8319 10.1351 12.8319C11.5345 12.8319 12.6689 11.6975 12.6689 10.2981Z" stroke="#6D76A1" stroke-width="1.52027" />
                                                                </svg>
                                                            </button>
                                                            <button onClick={() => deleteAgency(data._id)}>
                                                                <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M16.6523 4.80811L16.1289 13.2752C15.9952 15.4386 15.9283 16.5202 15.3861 17.2979C15.118 17.6823 14.7728 18.0068 14.3725 18.2507C13.5629 18.7439 12.4792 18.7439 10.3117 18.7439C8.14144 18.7439 7.05629 18.7439 6.24611 18.2498C5.84556 18.0055 5.50029 17.6804 5.23229 17.2953C4.69022 16.5164 4.62483 15.4332 4.49405 13.2668L3.9834 4.80811" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                                                    <path d="M2.71631 4.80764H17.919M13.7431 4.80764L13.1665 3.61822C12.7835 2.82813 12.592 2.43308 12.2617 2.1867C12.1884 2.13205 12.1108 2.08344 12.0297 2.04134C11.6639 1.85156 11.2249 1.85156 10.3468 1.85156C9.44674 1.85156 8.9967 1.85156 8.62482 2.0493C8.54241 2.09312 8.46376 2.1437 8.3897 2.20052C8.05553 2.45688 7.86887 2.86639 7.49554 3.6854L6.98398 4.80764" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                                                    <path d="M8.20605 14.0981L8.20605 9.03058" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                                                    <path d="M12.4292 14.0983L12.4292 9.03076" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                                                </svg>
                                                            </button>
                                                            <div className="dropdown">
                                                                <button className="border-0 bg-none" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="fas fa-ellipsis-v"></i>
                                                                </button>
                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                    <li><Link className="dropdown-item approve_btn" onClick={() => { agencyApproval('approve', data._id) }}>Approve</Link></li>
                                                                    <li><Link className="dropdown-item reject_btn" onClick={() => { handleClickOpen(); setAgencyId(data._id) }}>Reject</Link></li>

                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                                <hr />
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <TableRow className="table_row" sx={{ marginBottom: 2 }}>
                                            <TableCell colSpan={5} className="text-center td"></TableCell>
                                            <TableCell className="text-center td">No result</TableCell>
                                            <TableCell colSpan={5} className="text-center td"></TableCell>
                                        </TableRow>
                                    )}
                                </TableBody >
                            </Table>
                        </TableContainer>
                        {/* Pagination */}
                        <div className="d-flex justify-content-end mt-3">
                            <Pagination
                                count={Math.ceil(paginatedAgencies.length / rowsPerPage)}
                                page={page}
                                onChange={handlePageChange}
                                className="custom-pagination"

                            />
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={open}
                keepMounted
                fullWidth
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className="container-fluid">
                    <div className="row px-0">
                        <div className="col-md-12 px-1 m-0">
                            <div className="card add_new_modal border-0 px-0 pb-2">
                                <div className="card-header bg-white">
                                    Agency Account Rejection
                                </div>
                                <div className="card-body pt-1">
                                    <div className="row">

                                        <div className="data my-1 col-md-12 px-1">
                                            <label htmlFor="" >Write here:</label>
                                            <textarea value={reason} onChange={(e) => setReason(e.target.value)} className='mt-1' id="" />
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="text-end mt-1 pb-0">
                                    <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleClose()}>Cancel</button>
                                    <button className="btn save_btn mx-2 " type='submit' onClick={() => agencyApproval('reject')}>Reject</button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </Dialog>


            {/* Custom Date Range Modal */}
            <Dialog className='custom_date_modal p-0'
                open={openModal}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <div className="container-fluid">
                    <div className="row ">
                        <div className="col-md-12 text-center pb-2 px-0 m-0">
                            <div className="content px-4 text-center">
                                <h6 className='my-3 '>Custom filter!</h6>
                                <Box
                                    component="form"
                                    sx={{
                                        '& .MuiTextField-root': { m: 0.5, width: '15ch' },  // Reduced margin
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <div>
                                        <TextField
                                            id="date-from"
                                            label="Date From"
                                            type="date"
                                            value={dateFrom}
                                            onChange={(e) => setDateFrom(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,  // Ensures label doesn't overlap with date input
                                            }}
                                            sx={{
                                                '& .MuiInputBase-root': { height: '35px' },  // Minimize height
                                                '& .MuiInputLabel-root': { fontSize: '12px' }, // Minimize label font size
                                                '& .MuiInputBase-input': { fontSize: '12px' }  // Minimize input text font size
                                            }}
                                        />
                                        <TextField
                                            id="date-to"
                                            label="Date To"
                                            type="date"
                                            value={dateTo}
                                            onChange={(e) => setDateTo(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,  // Ensures label doesn't overlap with date input
                                            }}
                                            sx={{
                                                '& .MuiInputBase-root': { height: '35px' },  // Minimize height
                                                '& .MuiInputLabel-root': { fontSize: '12px' }, // Minimize label font size
                                                '& .MuiInputBase-input': { fontSize: '12px' }  // Minimize input text font size
                                            }}
                                        />
                                    </div>
                                </Box>
                            </div>
                            <button className="cancel m-1 py-1 px-2" onClick={() => { handleCloseModal(); setDateFrom(''); setDateTo(''); setFilterValue('') }}>Cancel</button>
                            <button className="m-1 py-1 px-2 active" onClick={handleCloseModal}>Filter</button>
                        </div>
                    </div>
                </div>

            </Dialog>
        </div >
    )
}
